import { useQuery } from '@tanstack/react-query';

import type { RiskBandSetQuery } from 'api/RiskBandsApi';
import { RiskBandsApi } from 'api/RiskBandsApi';
import { RISK_BANDS_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';

export function useRiskBandSets(query?: RiskBandSetQuery) {
  const riskBandsApi = new RiskBandsApi();
  const { userBankId } = useUser();

  const { data: riskBandSets, isLoading: isLoadingRiskBandSets } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [RISK_BANDS_KEY, userBankId, query],
    queryFn: () => riskBandsApi.queryRiskBandSets(userBankId, query)
  });

  return { riskBandSets, isLoadingRiskBandSets };
}
